
import { greekSearchFilter } from "@/helpers/data";
import { commonModule } from '@/store/modules/store-accessor';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class PriorityCombo extends Vue {
    @Prop({ default: 'MEDIUM' })
    readonly value!: string | null;

    label = this.$i18n.t('priority');

    greekSearchFilter = greekSearchFilter;

    async mounted() {
        await commonModule.getPrioritiesCombo();
        // If parent hasn't set a value, initialize it to the default
        if (!this.value) {
            this.$emit('input', 'MEDIUM');
        }
    }

    get priorityOptions() {
        return commonModule.prioritiesCombo;
    }

    get internalValue(): string | null {
        return this.value;
    }

    set internalValue(newValue: string | null) {
        this.$emit('input', newValue);
    }

    rules = [
        (val: any) => !!val || this.$i18n.t('priorityRequired'),
    ];
}
